import { render, staticRenderFns } from "./UserGameData.vue?vue&type=template&id=0266026c&"
import script from "./UserGameData.vue?vue&type=script&lang=js&"
export * from "./UserGameData.vue?vue&type=script&lang=js&"
import style0 from "./UserGameData.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports